//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import connApi from '~/assets/js/connector/api.js'

export default {
  name: 'ConnectorDashboard',
  props: {
    c: { type: Object, required: true },
    uid: { type: [String, Number], required: true }
  },
  data () {
    return {
      page: 'conn',
      // 密钥
      signalLoaded: false,
      credentials: {},
      showKey: false,
      keyFresh: false,
      keyCopied: false,
      regenLoading: false,
      showRegenConfirm: false,
      // 证书
      licenses: [],
      licenseLoading: false,
      // 信号日志
      signals: [],
      signalLoading: false,
      signalPage: 1,
      logFilterLic: '',
      logFilterStatus: '',
      pageSize: 8,
      // 代码生成
      activePreset: 'simple',
      genTab: 0,
      genOutput: { json: '', pine: '', alert: '' },
      gen: {
        license: '',
        key: '',
        cmd: 'buy',
        symbol: 'EURUSD',
        price: '',
        lots: '',
        magic: '',
        comment: '',
        slpoints: '',
        slprice: '',
        slpct: '',
        tppoints: '',
        tpprice: '',
        tppct: '',
        signalid: '',
        timestamp: '',
        expiryseconds: '60'
      },
      // 下载
      dlSelected: 'mt5',
      showDisclaimer: false,
      disclaimerAgreed: false,
      // Toast
      toastMsg: '',
      toastType: 'info',
      toastShow: false,
      toastTimer: null
    }
  },
  computed: {
    webhookBase () {
      return process.env.NODE_ENV !== 'production'
        ? 'https://wss.otvps.com/ws/v3'
        : 'https://wss.otvps.com/ws/v3'
    },
    showPriceField () {
      return ['buylimit', 'selllimit', 'buystop', 'sellstop'].includes(this.gen.cmd)
    },
    filteredSignals () {
      return this.signals.filter((s) => {
        if (this.logFilterLic && s.license_id !== this.logFilterLic) return false
        if (this.logFilterStatus && s.status !== this.logFilterStatus) return false
        return true
      })
    },
    pagedSignals () {
      const start = (this.signalPage - 1) * this.pageSize
      return this.filteredSignals.slice(start, start + this.pageSize)
    },
    totalPages () {
      return Math.max(1, Math.ceil(this.filteredSignals.length / this.pageSize))
    },
    presets () {
      return {
        simple: { label: this.c.presetSimple },
        sltp: { label: this.c.presetSltp },
        close: { label: this.c.presetClose },
        pending: { label: this.c.presetPending },
        reverse: { label: this.c.presetReverse || '🔄 反手（平+开）' }
      }
    },
    sortedLicenses () {
      return [...this.licenses].sort((a, b) => {
        const la = String(a.license_id || '').toLowerCase()
        const lb = String(b.license_id || '').toLowerCase()
        return la < lb ? -1 : la > lb ? 1 : 0
      })
    }
  },
  errorCaptured (err, vm, info) {
    return false
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      Promise.all([this.loadCredentials(), this.loadLicenses()]).catch(() => {})
    },

    loadCredentials () {
      return connApi.getCredentials({ uid: this.uid })
        .then((res) => {
          const d = res && res.data
          if (!d) return
          if (d.code === 0) {
            this.credentials = d.data || {}
          } else if (d.secret_key) {
            this.credentials = d
          }
        })
        .catch(() => {})
    },

    loadLicenses () {
      this.licenseLoading = true
      return connApi.getLicenses({ uid: this.uid })
        .then((res) => {
          const d = res && res.data
          if (!d) return
          // 兼容多种响应格式
          if (d.code === 0) {
            const raw = d.data
            this.licenses = Array.isArray(raw) ? raw : (raw ? [raw] : [])
          } else if (Array.isArray(d)) {
            this.licenses = d
          } else if (d.data && Array.isArray(d.data)) {
            this.licenses = d.data
          }
        })
        .catch(() => {})
        .finally(() => { this.licenseLoading = false })
    },

    gotoLog () {
      try {
        this.page = 'log'
        this.$nextTick(() => {
          try { this.loadSignals() } catch (e) {}
        })
      } catch (e) {}
    },

    refreshSignals () {
      this.signalLoaded = false
      this.loadSignals()
    },

    loadSignals () {
      if (this.signalLoaded) return
      this.signalLoading = true
      connApi.getSignals({ uid: this.uid, page: 1, limit: 100 })
        .then((res) => {
          if (res && res.data && res.data.code === 0) {
            const d = res.data.data || {}
            this.signals = Array.isArray(d) ? d : (d.signals || [])
            this.signalLoaded = true
          }
        })
        .catch(() => {})
        .finally(() => { this.signalLoading = false })
    },

    doRegen () {
      this.regenLoading = true
      this.showRegenConfirm = false
      connApi.regenerateKey({ uid: this.uid })
        .then((res) => {
          if (res && res.data && res.data.code === 0) {
            return this.loadCredentials().then(() => {
              this.keyFresh = true
              this.showKey = true
              this.toast(this.c.toastRegen, 'ok', 5000)
            })
          }
        })
        .catch(() => {})
        .finally(() => { this.regenLoading = false })
    },

    toggleKey () {
      this.showKey = !this.showKey
      this.keyFresh = false
    },

    copyKey () {
      this.copyToClipboard(this.credentials.secret_key || '')
      this.keyCopied = true
      this.keyFresh = false
      this.toast(this.c.toastKeyCopied, 'ok')
      setTimeout(() => { this.keyCopied = false }, 2000)
    },

    copyText (text) {
      this.copyToClipboard(text)
      this.toast(this.c.toastCopied, 'ok')
    },

    copyToClipboard (text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text)
      } else {
        const el = document.createElement('textarea')
        el.value = text
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
      }
    },

    onCmdChange () {
      if (!this.showPriceField) this.gen.price = ''
    },

    setPreset (key) {
      this.activePreset = key
      this.gen = { license: this.gen.license, key: this.gen.key, cmd: 'buy', symbol: 'EURUSD', price: '', lots: '', magic: '', comment: '', slpoints: '', slprice: '', slpct: '', tppoints: '', tpprice: '', tppct: '', signalid: '', timestamp: '', expiryseconds: '60' }
      if (key === 'sltp') { this.gen.slpoints = '50'; this.gen.tppoints = '100' }
      if (key === 'close') { this.gen.cmd = 'closeall' }
      if (key === 'pending') { this.gen.cmd = 'buylimit'; this.gen.price = '1.0800'; this.gen.lots = '0.1'; this.gen.slpoints = '30'; this.gen.tppoints = '60' }
      if (key === 'reverse') { this.gen.cmd = 'closesell'; this.gen.symbol = 'XAUUSD' }
      this.genOutput = { json: '', pine: '', alert: '' }
    },

    genUUID () {
      this.gen.signalid = 'TV_' + (this.gen.symbol || 'SYM') + '_' + this.gen.cmd.toUpperCase() + '_' + Date.now()
    },

    genTimestamp () {
      this.gen.timestamp = Math.floor(Date.now() / 1000).toString()
    },

    generateCode () {
      if (!this.gen.license || !this.gen.key || !this.gen.symbol) {
        this.toast(this.c.toastIncomplete || '信息不完整，请填写必填项', 'err')
        return
      }
      const obj = {
        license: this.gen.license,
        key: this.gen.key,
        cmd: this.gen.cmd,
        symbol: this.gen.symbol.toUpperCase()
      }
      const isClose = ['closebuy', 'closesell', 'closeall', 'closeallorders'].includes(this.gen.cmd)
      const numFields = ['price', 'slpoints', 'slprice', 'slpct', 'tppoints', 'tpprice', 'tppct', 'magic', 'expiryseconds']
      numFields.forEach((k) => { if (this.gen[k]) obj[k] = parseFloat(this.gen[k]) })
      // lots 只在非平仓指令时加入
      if (this.gen.lots && !isClose) obj.lots = parseFloat(this.gen.lots)
      const strFields = ['comment', 'signalid', 'timestamp']
      strFields.forEach((k) => { if (this.gen[k]) obj[k] = this.gen[k] })

      const jsonStr = JSON.stringify(obj, null, 2)
      const jsonOneLine = JSON.stringify(obj)

      // Pine Script - alert() 方式
      const varN = isClose ? 'closeMessage' : (this.gen.cmd.includes('buy') ? 'buyMessage' : 'sellMessage')
      const sym = this.gen.symbol || 'EURUSD'
      const lotsStr = obj.lots ? `,"lots":${obj.lots}` : ''
      const slStr = obj.slpoints ? `,"sl_points":${obj.slpoints}` : (obj.slprice ? `,"sl_price":${obj.slprice}` : '')
      const tpStr = obj.tppoints ? `,"tp_points":${obj.tppoints}` : (obj.tpprice ? `,"tp_price":${obj.tpprice}` : '')
      const pine = `//@version=6
strategy("WikiConnector Strategy", overlay=true)

// ===== Signal message definition =====
${varN} = '{"license":"${obj.license}","key":"${obj.key}","cmd":"${this.gen.cmd}","symbol":"' + syminfo.ticker + '"${lotsStr}${slStr}${tpStr}}'

// ===== Use alert.freq_all to ensure all signals within the same bar are sent =====
if YOUR_CONDITION
    alert(${varN}, alert.freq_all)

// ===== Reverse example (close short, then open long) =====
// closesellMsg = '{"license":"${obj.license}","key":"${obj.key}","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'
// buyMsg       = '{"license":"${obj.license}","key":"${obj.key}","cmd":"buy","symbol":"' + syminfo.ticker + '"${lotsStr}}'
// if longCondition
//     alert(closesellMsg, alert.freq_all)   // close short first
//     alert(buyMsg,       alert.freq_all)   // then open long`

      // Alert setup instructions
      const alertTxt = `============================================
  TradingView Alert Setup (alert() method)
============================================

[Create Alert - Main Settings]
Condition      : Select your strategy name
Trigger        : ✅ alert() function calls only  ← Important!
Timeframe      : Same as chart
Expiration     : Set as long as possible or Open-ended
Message        : Leave default, do not fill in anything  ← Important!

[Notifications]
Notify on App  : ✅ Optional
Show popup     : ✅ Optional
Webhook URL    : ✅ Check and enter:
                 https://api-gw.interface003.com/webhook/v3/
Send as plain  : ❌ Uncheck this

============================================
Generated JSON signal:
${jsonOneLine}
============================================`

      this.genOutput = { json: jsonStr, pine, alert: alertTxt }
    },

    copyGenOutput (type) {
      const text = type === 'json' ? this.genOutput.json : type === 'pine' ? this.genOutput.pine : this.genOutput.alert
      this.copyToClipboard(text)
      this.toast(this.c.toastCodeCopied, 'ok')
    },

    confirmDownload () {
      if (!this.disclaimerAgreed) return
      this.showDisclaimer = false
      const link = document.createElement('a')
      link.href = 'https://rating.zy223.com/eashop/Ea/WikiConnector/WikiFX-SignalReceiver.ex5'
      link.download = 'WikiFX-SignalReceiver.ex5'
      link.click()
      this.toast(this.c.toastDownloadStart || 'Download started', 'ok')
    },

    formatTime (ts) {
      if (!ts) return '-'
      const d = new Date(ts)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getMonth() + 1}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },

    statusText (status) {
      const map = { delivered: this.c.statusDelivered, pending: this.c.statusPending, failed: this.c.statusFailed, expired: this.c.statusExpired }
      return map[status] || status
    },

    cmdPill (cmd) {
      if (!cmd) return 'p-cmd'
      if (['buy', 'buylimit', 'buystop'].includes(cmd)) return 'p-buy'
      if (['sell', 'selllimit', 'sellstop'].includes(cmd)) return 'p-sell'
      return 'p-cmd'
    },

    statusPill (status) {
      return { 'p-ok': status === 'delivered', 'p-err': status === 'failed', 'p-cmd': ['pending', 'expired'].includes(status) }
    },

    toast (msg, type = 'info', duration = 2500) {
      clearTimeout(this.toastTimer)
      this.toastMsg = msg
      this.toastType = type
      this.toastShow = true
      this.toastTimer = setTimeout(() => { this.toastShow = false }, duration)
    }
  }
}
